export default {
  DASHBOARD: '/dashboard',
};